"use client";

import { AnimatePresence, motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { EASE } from "../../constants";
import { type LeadStatus, STATUS_CLASS, STATUS_LABEL } from "./data";

// Animated lifecycle label, shared by the thread header and the spotlight
// identity card so they always stay in sync.
export function StatusText({
  status,
  reduce,
  className,
}: {
  status: LeadStatus;
  reduce: boolean;
  className?: string;
}) {
  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.p
        key={status}
        initial={reduce ? false : { opacity: 0, y: 4 }}
        animate={{ opacity: 1, y: 0 }}
        exit={reduce ? undefined : { opacity: 0, y: -4 }}
        transition={{ duration: 0.25, ease: EASE }}
        className={cn(
          "text-[11px] font-medium leading-tight",
          STATUS_CLASS[status],
          status === "member" && "font-semibold",
          className,
        )}
      >
        {STATUS_LABEL[status]}
      </motion.p>
    </AnimatePresence>
  );
}
